import { render, staticRenderFns } from "./ProductWorkflowUnits.vue?vue&type=template&id=2b74f912"
import script from "./ProductWorkflowUnits.vue?vue&type=script&lang=js"
export * from "./ProductWorkflowUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports